/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrderEntry } from './OrderEntry';
import {
    OrderEntryFromJSON,
    OrderEntryFromJSONTyped,
    OrderEntryToJSON,
} from './OrderEntry';

/**
 * List of entries containing the amount to add and the product code or the entryNumber.
 * @export
 * @interface OrderEntryList
 */
export interface OrderEntryList {
    /**
     * List of order entries
     * @type {Array<OrderEntry>}
     * @memberof OrderEntryList
     */
    orderEntries?: Array<OrderEntry>;
}

/**
 * Check if a given object implements the OrderEntryList interface.
 */
export function instanceOfOrderEntryList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrderEntryListFromJSON(json: any): OrderEntryList {
    return OrderEntryListFromJSONTyped(json, false);
}

export function OrderEntryListFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderEntryList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderEntries': !exists(json, 'orderEntries') ? undefined : ((json['orderEntries'] as Array<any>).map(OrderEntryFromJSON)),
    };
}

export function OrderEntryListToJSON(value?: OrderEntryList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderEntries': value.orderEntries === undefined ? undefined : ((value.orderEntries as Array<any>).map(OrderEntryToJSON)),
    };
}

